import style from './input.module.scss'

const Input = ({type = 'text' , error, required = false, width, height, border, borderRadius, placeholder, background, color, value, setValue, margin, options}) => {
    const config = {
        width: width || '100%',
        height: height || 'fit-content',
        margin: margin || '0',
        border: error ? '1px solid red' : border || '0',
        borderRadius: borderRadius || '0',
        background: background || '',
        color: color || '',
    }

    const onChangeValue = (e) => {
        e.preventDefault()
        setValue(e.target.value)
    }

    if (type === 'select') {
        return (
        <select
            className={style.select}
            style={config}
            value={value}
            onChange={onChangeValue}
            required={required}
        >
            <option value="">{placeholder || 'Выберите...'}</option>
            {options?.map((option) => (
            <option key={option.value} value={option.value}>
                {option.label}
            </option>
            ))}
        </select>
        )
    } else {
        return (
            <input
                className={style.input}
                style={config}
                value={value}
                onChange={onChangeValue}
                placeholder={placeholder}
                required={required}
            >
            </input>
        )
    }
}

export default Input